interface EmployeeLike {
  email?: string|null
}
export const isServiceAccount = (employee: EmployeeLike) => {
  return employee && employee.email && employee.email.endsWith('@ventumsoftware.nl');
}